import { useState } from "react";
import { useTranslation } from "react-i18next";
import { CareerInterestModal } from "./CareerInterestModal";
import { formatMonthYear } from "Utils";

export const CareerInterest = ({
  careerInterestData,
  fetchData,
  isCurrentUserProfile,
}) => {
  const { t } = useTranslation();

  const [careerInterestModal, setCareerInterestModal] = useState(false);

  const toggleCareerInterestModal = () => {
    setCareerInterestModal((prev) => !prev);
  };

  return (
    <>
      <div className="p-4 rounded-lg border border-grey-200 bg-white d-flex flex-column gap-0">
        <div className="d-flex flex-wrap justify-content-between align-items-center column-gap-3 row-gap-2 mb-3">
          <h4 className="mb-0 text-md font-semibold text-grey-800">
            {t("auth.viewProfile.careerInterest")}
          </h4>
          {isCurrentUserProfile && (
            <div className="d-flex align-items-center gap-1">
              <button
                type="button"
                className="text-md text-grey-600 text-decoration-none btn btn-link w-8 h-8 d-flex justify-content-center align-items-center"
                onClick={toggleCareerInterestModal}
              >
                <i className="bx bx-pencil"></i>
              </button>
            </div>
          )}
        </div>
        <ul className="careerInterest-list list-unstyled mb-0 d-flex flex-column">
          {careerInterestData ? (
            <>
              <li className="py-3">
                <label className="mb-2 form-label font-medium text-grey-500">
                  Career Goals
                </label>
                <div className="text-sm font-normal text-grey-800">
                  <ul className="list-unstyled mb-0 d-inline-flex flex-wrap gap-1">
                    <li>
                      <span className="d-inline-block px-3 py-1-5 text-xs font-medium text-primary-900 rounded-lg bg-primary-50">
                        {careerInterestData.careerGoalText}
                      </span>
                    </li>
                    {careerInterestData.careerGoals &&
                      careerInterestData.careerGoals.length > 0 &&
                      careerInterestData.careerGoals.map((item, idx) => (
                        <li key={idx.toString()}>
                          <span className="d-inline-block px-3 py-1-5 text-xs font-medium text-primary-900 rounded-lg bg-primary-50">
                            {item}
                          </span>
                        </li>
                      ))}
                  </ul>
                </div>
              </li>
              <li className="py-3">
                <div className="">
                  <label className="mb-2 form-label font-medium text-grey-500">
                    I'm Looking For
                  </label>
                  <div className="text-sm font-normal text-grey-800">
                    <ul className="list-unstyled mb-0 d-inline-flex flex-wrap gap-1">
                      {careerInterestData.lookingFor &&
                        careerInterestData.lookingFor.length > 0 &&
                        careerInterestData.lookingFor.map((item, idx) => (
                          <li key={idx.toString()}>
                            <span className="d-inline-block px-3 py-1-5 text-xs font-medium text-primary-900 rounded-lg bg-primary-50">
                              {item}
                            </span>
                          </li>
                        ))}
                    </ul>
                  </div>
                </div>
              </li>
              <li className="py-3">
                <div className="">
                  <label className="mb-1 form-label font-medium text-grey-500">
                    Availability
                  </label>
                  <div className="text-sm font-semibold text-grey-800">
                    <ul className="careerlink-list list-unstyled mb-0 d-inline-flex">
                      <li>
                        <span>
                          {careerInterestData.availabilityDate
                            ? formatMonthYear(
                                careerInterestData.availabilityDate
                              )
                            : ""}
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </li>
              <li className="py-3">
                <div className="">
                  <label className="mb-1 form-label font-medium text-grey-500">
                    Availability Type
                  </label>
                  <div className="text-sm font-semibold text-grey-800">
                    <ul className="careerlink-list list-unstyled mb-0 d-inline-flex">
                      <li>
                        <span>{careerInterestData.availabilityType}</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </li>
            </>
          ) : (
            <li>
              <div className="">
                <span className="text-grey-400">
                  {t("auth.viewProfile.noCareerInterest")}
                </span>
              </div>
            </li>
          )}
        </ul>
      </div>

      {careerInterestModal && (
        <CareerInterestModal
          show={careerInterestModal}
          careerInterestData={careerInterestData}
          toggle={toggleCareerInterestModal}
          fetchData={fetchData}
        />
      )}
    </>
  );
};
